export default __webpack_public_path__ + "static/media/M2Doubts.5be0af42.png";